import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "../../components/ui/sonner";
import { Badge } from "../../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { QUOTE_STATUSES } from "../../lib/constants";

const statusVariant = { new: "default", quoted: "secondary", dispatched: "secondary", closed: "outline" };

export function QuotesManager({ onChange }) {
  const [quotes, setQuotes] = useState([]);

  const load = () => api.get("/quotes").then((res) => setQuotes(res.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/quotes/${id}`, { status });
      toast.success("Status updated");
      load();
      onChange?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Update failed");
    }
  };

  return (
    <div data-testid="admin-quotes-manager" className="border border-amber-500/10 rounded-md overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="border-amber-500/10">
            <TableHead>Customer</TableHead>
            <TableHead>Contact</TableHead>
            <TableHead>Vehicle / Equipment</TableHead>
            <TableHead>Part</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {quotes.map((q) => (
            <TableRow key={q.id} className="border-amber-500/10" data-testid={`admin-quote-row-${q.id}`}>
              <TableCell className="text-white">{q.name}<div className="text-xs text-zinc-500">{q.company}</div></TableCell>
              <TableCell className="text-zinc-400 text-sm">{q.email}<div>{q.phone}</div></TableCell>
              <TableCell className="text-zinc-400 text-sm">{q.vehicle_info}</TableCell>
              <TableCell className="text-zinc-400 text-sm font-mono">{q.part_sku || "—"}</TableCell>
              <TableCell>
                <Select value={q.status} onValueChange={(v) => updateStatus(q.id, v)}>
                  <SelectTrigger data-testid={`admin-quote-status-select-${q.id}`} className="w-36">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {QUOTE_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                  </SelectContent>
                </Select>
              </TableCell>
            </TableRow>
          ))}
          {quotes.length === 0 && (
            <TableRow><TableCell colSpan={5} className="text-center text-zinc-500 py-8" data-testid="admin-quotes-empty">No quote requests yet.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
